(() => {
  if (window.countrylookReadingReady) return;
  window.countrylookReadingReady = true;
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  let printOpen = [];
  function openStory(target, focus = false) {
    const story = target?.matches('.cl-winner') ? target : target?.matches('.cl-award-card') ? target.querySelector('.cl-winner') : null;
    if (!story) return;
    story.open = true;
    const card = story.closest('.cl-award-card') || story;
    requestAnimationFrame(() => {
      card.scrollIntoView({block: 'start'});
      if (focus) story.querySelector('summary')?.focus({preventScroll: true});
    });
  }
  function openHash() {
    try { openStory(document.getElementById(decodeURIComponent(location.hash.slice(1)))); } catch {}
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-story]');
    if (!close) return;
    const story = close.closest('.cl-winner');
    story.open = false;
    const toggle = story.querySelector('summary');
    toggle?.focus({preventScroll: true});
    toggle?.scrollIntoView({block: 'center'});
  });
  function init() {
    all('[data-enhanced]').forEach(el => { el.hidden = false; });
    const header = document.querySelector('.section-header');
    document.documentElement.style.setProperty('--cl-header-offset', Math.min(header?.offsetHeight || 0, 180) + 'px');
  }
  function ready() { init(); openHash(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  window.addEventListener('hashchange', openHash);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', event => openStory(event.target, true));
  window.addEventListener('beforeprint', () => {
    printOpen = all('.cl-winner[open]');
    all('.cl-winner').forEach(story => { story.open = true; });
  });
  window.addEventListener('afterprint', () => all('.cl-winner').forEach(story => { story.open = printOpen.includes(story); }));
})();
